module.exports = __webpack_public_path__ + "media/images/client-24-8b578abfeeea4ad6f2a30eded3468d62.png";